import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {FoundMeasurement} from "../../../found-measurement";
import {ApiClient} from "../../../../../tools/api-client";
import {recursiveNullToUndefined} from "../../../../../tools/recursive-null-to-undefined";
import {TODO} from "../../../../../tools/test/todo";

export interface ReassignTechnicianRequest {
  readonly measurementId: number;
  readonly technicianId: number;
}

@Injectable()
export class ReassignTechnicianService {

  constructor(private readonly apiClient: ApiClient) {
  }

  reassign(request: ReassignTechnicianRequest): Observable<FoundMeasurement> {
    return this.apiClient
      .put<FoundMeasurement>(
        `api/measurements/${request.measurementId}/reassign-technician`,
        {technicianId: request.technicianId}
      )
      .pipe(map(recursiveNullToUndefined));
  }
}
